<!--
@deprecated use <AppSelectUser/> instead
-->

<template>
    <AppDropdown
        :id="componentId"
        :data="membersData"
        @select="onSelect"
        @dropdown-hide="hoveredDropdownUserUuid = null"
        :disabled="disabled"
        :align="dropdownAlign"
        :stopPropagation="stopPropagation"
        :search="{ show: true, property: 'fullName', caseSensitive: false }"
        :showMenuButton="showMenuButton">

        <template slot="menu-button">

            <!-- default -->
            <slot name="menu-button">
                <div v-for="(uuid, idx) in assignedUserUuids.slice(0, displayedQty)" :key="uuid"
                     @mouseover="hoveredMenuButtonUserUuid = uuid"
                     @mouseleave="hoveredMenuButtonUserUuid = null"
                     class="avatar-wrap"
                     :style="{
                         'z-index': displayedQty - idx + 1,
                         'margin-left': `${idx === 0 ? '0' : '-12'}px`
                     }">
                    <div class="position-relative">
                        <avatar
                            v-tooltip.top="getAssignedUserName(uuid) || 'Not assigned'"
                            :size="29"
                            :inline="true"
                            :customStyle="{ 'vertical-align': 'middle' }"
                            :src="getAssignedUserAvatar(uuid)"
                            :username="getAssignedUserName(uuid)">
                        </avatar>
                        <div v-if="uuid !== userUUID && hoveredMenuButtonUserUuid !== uuid && membersPresence[uuid]"
                             class="is-online-user">
                        </div>
                    </div>
                    <div v-if="!disabled && hoveredMenuButtonUserUuid === uuid"
                         @click.stop="onSelect(getAssignedUser(uuid))"
                         class="remove-user-btn">
                        <span class="text-white">
                            <i class="fa fa-times"></i>
                        </span>
                    </div>
                </div>
                <div v-if="assignedUserUuids.length > displayedQty" class="exceed-quantity">
                    <div v-tooltip.top="`${assignedUserUuids.length - displayedQty} more people`" class="text-center">
                        <div class="exceed-quantity-number">
                            {{ assignedUserUuids.length - displayedQty }}
                        </div>
                    </div>
                </div>

                <div v-if="!disabled" class="assign-btn"
                     :style="{ 'margin-left': `${assignedUserUuids.length === 0 ? '0' : '-12'}px` }">
                    <span v-tooltip.top="'Assign'" class="emptyIconCircle text-center">
                        <i class="fal fa-user"></i>
                    </span>
                    <div class="assign-btn-plus">
                        <i class="fa fa-plus"></i>
                    </div>
                </div>
            </slot>

        </template>

        <template v-if="!disabled" #item="{ item }">
            <div @mouseover="hoveredDropdownUserUuid = item.uuid"
                 @mouseleave="hoveredDropdownUserUuid = null"
                 class="row flex-nowrap px-1 m-0">
                <div class="col-1 align-self-center pl-0">
                    <div class="position-relative" style="width: 24px">
                        <avatar
                            :username="item.firstName + ' ' + item.lastName"
                            :size="24"
                            :src="membersAvatars[item.uuid]">
                        </avatar>
                        <div v-if="item.uuid !== userUUID && membersPresence[item.uuid]" class="is-online-user"></div>
                    </div>
                </div>
                <div class="col-10 align-self-center pl-4 pr-1"
                     :class="{ 'text-bold': assignedUserUuids.indexOf(item.uuid) !== -1 }">
                    {{ item.firstName }} {{ item.lastName }}
                </div>
                <div class="col-1 pl-1 align-self-center pl-0">
                    <div v-show="assignedUserUuids.indexOf(item.uuid) !== -1 && hoveredDropdownUserUuid !== item.uuid"
                         class="text-muted" style="width: 16px">
                        <i class="fal fa-sm fa-check"></i>
                    </div>
                    <div v-show="assignedUserUuids.indexOf(item.uuid) !== -1 && hoveredDropdownUserUuid === item.uuid"
                         class="text-danger" style="width: 16px">
                        <i class="fal fa-sm fa-times"></i>
                    </div>
                </div>
            </div>
        </template>

    </AppDropdown>
</template>

<script>
import {mapGetters} from 'vuex'
import {getUserFullName} from '@/utils/user'
import {UNASSIGNED} from '@/types/data'

export default {
    name: 'AppAssignUserMultiple',
    props: {
        componentId: {
            type: String,
            default: () => 'assign-multiple-' + Math.random()
        },
        uuids: { // assigned users uuid list
            required: true,
            type: Array
        },
        users: {
            required: false,
            type: Array
        },
        showMenuButton: {
            type: Boolean,
            default: true
        },
        withUnassign: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        stopPropagation: {
            type: Boolean,
            default: false
        },
        dropdownAlign: {
            type: String,
            default: 'left'
        },
        displayedQty: {
            type: Number,
            default: 3
        }
    },
    data() {
        return {
            hoveredMenuButtonUserUuid: null,
            hoveredDropdownUserUuid: null
        }
    },
    model: {
        prop: 'uuids',
        event: 'change:uuids'
    },
    computed: {
        ...mapGetters([
            'getMembers',
            'getActiveMembers',
            'userUUID',
            'membersPresence',
            'membersAvatars'
        ]),

        membersData() {
            let data = []
            if (this.users) {
                data = this.users
            } else {
                data = [...this.getActiveMembers]
            }
            if (this.withUnassign) {
                data.push({uuid: UNASSIGNED, firstName: 'Unassign', lastName: ''})
            }
            return data.map(user => ({...user, fullName: getUserFullName(user)}))
        },

        assignedUserUuids() { // TODO: update api so there are no duplicates
            return _.uniq(this.uuids)
        }
    },
    methods: {
        onSelect(member) {
            this.$emit('change', member)

            if (member.uuid === UNASSIGNED) {
                this.$emit('change:uuids', [])
                return
            }

            const uuids = _.cloneDeep(this.uuids)
            if (uuids.includes(member.uuid)) {
                uuids.splice(uuids.indexOf(member.uuid), 1)
            } else {
                uuids.push(member.uuid)
            }
            this.$emit('change:uuids', uuids)
        },

        getAssignedUser(uuid) {
            return this.getMembers.find(user => user.uuid === uuid)
        },

        getAssignedUserName(uuid) {
            return getUserFullName(this.getAssignedUser(uuid))
        },

        getAssignedUserAvatar(uuid) {
            return this.membersAvatars[uuid]
        }
    }
}
</script>

<style lang="scss" scoped>
$border: 1px solid white;

.avatar-wrap {
    height: 29px;
    border: $border;
    position: relative;
    display: inline-block;
    border-radius: 100%;
}

.remove-user-btn {
    position: absolute;
    display: inline-block;
    vertical-align: center;
    background: grey;
    border: $border;
    border-radius: 100%;
    top: -6px;
    right: -6px;
    width: 18px;
    height: 18px;
    font-size: 12px;
    line-height: 16px;
    text-align: center;

    &:hover {
        cursor: pointer;
        background: $color-danger;
    }
}

.assign-btn {
    position: relative;
    display: inline-block;

    &:hover {
        cursor: pointer;

        .emptyIconCircle {
            color: $color-success;
            border-color: $color-success;
        }

        .assign-btn-plus {
            background: $color-success;
        }
    }

    .assign-btn-plus {
        position: absolute;
        display: inline-block;
        vertical-align: middle;
        background: $color-grey-light;
        color: white;
        border: $border;
        border-radius: 100%;
        bottom: 0;
        right: 0;
        width: 18px;
        height: 18px;
        font-size: 12px;
        line-height: 16px;
        text-align: center;
    }
}

.exceed-quantity {
    position: relative;
    display: inline-block;
    height: 29px;
    width: 31px;
    line-height: 29px;
    margin-left: -12px;
    background: white;
    border: $border;
    border-radius: 100%;
    z-index: 1;
    text-align: center;
    vertical-align: middle;
    color: #cecece;
    font-size: 16px;
    transition: all .3s;

    .exceed-quantity-number {
        background: $color-grey-light;
        border-radius: 100%;
        color: white;
        font-size: 14px;
    }
}

.is-online-user {
    position: absolute;
    background-color: $color-success;
    top: 0;
    right: 0;
    width: 6px;
    height: 6px;
    border-radius: 50%;
}

</style>
